import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss']
})

export class CalculatorComponent implements OnInit {

  public result: string;
  public expresion: string;

  constructor(){
  }

  ngOnInit() {
    this.expresion = "";
  }

  public add(key: string) {
    if (
      key == '0' ||
      key == '1' ||
      key == '2' ||
      key == '3' ||
      key == '4' ||
      key == '5' ||
      key == '6' ||
      key == '7' ||
      key == '8' ||
      key == '9' ) {
        this.expresion += key
    } else {
      console.log(this.expresion.substring(this.expresion.length - 1, this.expresion.length));
      if (
      this.expresion.substring(this.expresion.length - 1, this.expresion.length) == '0' || 
      this.expresion.substring(this.expresion.length - 1, this.expresion.length) == '1' || 
      this.expresion.substring(this.expresion.length - 1, this.expresion.length) == '2' ||
      this.expresion.substring(this.expresion.length - 1, this.expresion.length) == '3' ||
      this.expresion.substring(this.expresion.length - 1, this.expresion.length) == '4' ||
      this.expresion.substring(this.expresion.length - 1, this.expresion.length) == '5' ||
      this.expresion.substring(this.expresion.length - 1, this.expresion.length) == '6' ||
      this.expresion.substring(this.expresion.length - 1, this.expresion.length) == '7' ||
      this.expresion.substring(this.expresion.length - 1, this.expresion.length) == '8' ||
      this.expresion.substring(this.expresion.length - 1, this.expresion.length) == '9') {
        this.expresion += key;
      }
      else {
        this.expresion = this.expresion.substring(0,this.expresion.length -1)
        this.expresion += key
      }
    }
    this.result = eval(this.expresion);
  }

  public delete() {
    this.expresion = this.expresion.substring(0,this.expresion.length - 1);
    this.result = eval(this.expresion);
  }

  public reset() {
    this.expresion = "";
    this.result = eval(this.expresion);
  }

  public getResult() {
    this.result = eval(this.expresion);
  }
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/components/calculator/calculator.component.ts